import Vue from 'vue'
import VueRouter from 'vue-router'
import Layout from '@/views/Layout/Index.vue'
import Home from '@/views/Home/Home.vue'
import Category from '@/views/Category/Index.vue'

Vue.use(VueRouter)
const routes = [
	{
	  path: '/',
	  component: Layout,
	  children: [
	    {
	      path: '',
	      component: Home
	    },
	    {
	      path: 'category',
	      component: Category
	    },
		{
		  path: '/product-detail',
		  component: () => import('@/views/Category/ProductDetail'),
		},
		{
		  path: '/product-comment',
		  component: () => import('@/views/Ucenter/ProductComments'),
		},
		{
		  path: '/ucenter',
		  component: () => import('@/views/Ucenter/Index'),
		},
		{
		  path: '/about',
		  component: () => import('@/views/Single/About'),
		},{
		  path: '/explain',
		  component: () => import('@/views/Single/Explain'),
		},{
		  path: '/news-detail',
		  component: () => import('@/views/Home/NewsDetail'),
		},
		{
		  path: '/activity-center',
		  component: () => import('@/views/Single/Activity'),
		},
		{
		  path: '/agency',
		  component: () => import('@/views/Agency/Index'),
		},
		{
		  path: '/agency-team',
		  component: () => import('@/views/Agency/Detail'),
		  meta: { requiresAuth: true }
		},
		{
		  path: '/favorite',
		  component: () => import('@/views/Ucenter/Favorite'),
		},
		{
		  path: '/cart',
		  component: () => import('@/views/Ucenter/Cart'),
		},
		{
		  path: '/confirm-order',
		  component: () => import('@/views/Ucenter/OrderConfirm'),
		},
		{
		  path: '/pay-order',
		  component: () => import('@/views/Ucenter/PayOrder'),
		},
		{
		  path: '/history',
		  component: () => import('@/views/Ucenter/History'),
		},
		{
		  path: '/my-order',
		  component: () => import('@/views/Ucenter/MyOrder'),
		},
		{
		  path: '/order-detail',
		  component: () => import('@/views/Ucenter/MyOrderDetail'),
		},
		{
		  path: '/wallet',
		  component: () => import('@/views/Ucenter/Uc-wallet'),
		},
		{
		  path: '/security-center',
		  component: () => import('@/views/Ucenter/Uc-security-center'),
		},
		{
		  path: '/address',
		  component: () => import('@/views/Ucenter/Uc-address'),
		},
		{
		  path: '/my-coupons',
		  component: () => import('@/views/Ucenter/Uc-deduction'),
		},
		{
		  path: '/bonus-plan',
		  component: () => import('@/views/Ucenter/Uc-bonus-plan'),
		},
		{
		  path: '/my-history',
		  component: () => import('@/views/Ucenter/Uc-history'),
		},
		{
		  path: '/m-set',
		  component: () => import('@/views/Ucenter/m-set'),
		},
		{
		  path: '/bank',
		  component: () => import('@/views/Ucenter/Uc-bank'),
		},
		{
		  path: '/consum-record',
		  component: () => import('@/views/Ucenter/Uc-consumRecord'),
		},
		{
		  path: '/commission-record',
		  component: () => import('@/views/Ucenter/Uc-commissionRecord'),
		},
	  ]
	},
	{
	  path: '/login',
	  component: () => import('@/views/Login'),
	},
	{
	  path: '/register',
	  component: () => import('@/views/Register'),
	},
	{
	  path: '/register-result',
	  component: () => import('@/views/Single/RegisterResult'),
	},
	{
	  path: '/set-result',
	  component: () => import('@/views/Single/SetResult'),
	},
	{
	  path: '/reset-password',
	  component: () => import('@/views/Single/RestPassword'),
	},
	{
	  path: '/reset-new',
	  component: () => import('@/views/Single/ResetNew'),
	},
	
	{
	  path: '/pay-sucess',
	  component: () => import('@/views/Single/pay-sucess'),
	},
	{
	  path: '/pay-error',
	  component: () => import('@/views/Single/pay-error'),
	},
	{
	  path: '/pay-result',
	  component: () => import('@/views/Single/pay-result'),
	},
	{
	  path: '/order-success',
	  component: () => import('@/views/Single/order-success'),
	},
	
]


const router = new VueRouter({
    routes,
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition
        } else {
            return { x: 0, y: 0 }
        }
    }
})


router.beforeEach((to, from, next) => {
	const loginPageArr = ['/ucenter','/favorite','/history',]
	const isLogin = localStorage.getItem('sp_tokenInfo')
	// 判断该路由是否需要登录权限
	if(loginPageArr.includes(to.path)){
		if (!isLogin) {
			if(from){
				next('/login')
			}else{
				next()
			}
			// next()
			return;
		}else{
			// 弹窗路由劫持
			if(initPopRouter(to,from,next)){
				next()
			}
		}
	 }else{
		// 弹窗路由劫持
		if(initPopRouter(to,from,next)){
			next()
		}
	 }
  })

// 初始化弹窗路由
const initPopRouter = (to,from,next)=>{
    let popArr = []
    if(popArr.includes(to.path)){
        next({path:from.path||"/",query:{
            dialog:to.path.split('/')[1]
        }})
    }else{
        return true
    }
}
export default router